"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({app}) {
        this.state = {
            app,
            dialog: false
        };
    },
    onDialog: function (arg) {
        this.state.dialog = arg;
    },
    onDelete: function () {
        this.onDialog({
            type: 'warning',
            message: 'All credentials, External & Internal Accesses will be removed along with app.',
            actions: {
                yes: {
                    label: 'Confirm',
                    fn: async function () {
                        try {
                            const {error, message, app} = await Request(`/app/${ this.state.app.appId }/delete`, 'DELETE');
                            if (error)
                                throw new Error(message);
                            this.emit('dismiss');
                            this.emit('refresh');
                        } catch (error) {
                            console.log('Failed Delete App: ', error);
                        }
                    }.bind(this)
                },
                no: { label: 'Cancel' }
            }
        });
    },
    sendUpdate: async function (updates) {
        try {
            const {error, message, app} = await Request(`/app/${ this.state.app.appId }/update`, 'PUT', updates);
            if (error)
                throw new Error(message);
            this.state.app = app;
            this.emit('refresh');
        } catch (error) {
            console.log('Failed Updating App mode: ', error);
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Apps/components/ViewApp.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Bx_template = require("../../../../components/Bx/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Bx_tag = marko_loadTag(Bx_template),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Switch_template = require("../../../../components/Switch/index.marko"),
    Switch_tag = marko_loadTag(Switch_template),
    Switcher_template = require("../../../../components/Switcher/index.marko"),
    Switcher_tag = marko_loadTag(Switcher_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    DialogModal_template = require("../../../../components/DialogModal/index.marko"),
    DialogModal_tag = marko_loadTag(DialogModal_template),
    marko_attrs0 = {
        "class": "position-absolute zindex-2 w-100 h-100 left-0 right-0 overflow-auto",
        style: "top:10%"
      },
    marko_attrs1 = {
        "class": "position-fixed top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      },
    marko_attrs2 = {
        "class": "list-unstyled border-top px-2 py-1"
      },
    marko_attrs3 = {
        "class": "py-1"
      },
    marko_attrs4 = {
        "class": "py-1"
      },
    marko_attrs5 = {
        "class": "list-unstyled border-top px-2 py-1"
      },
    marko_attrs6 = {
        "class": "py-1"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("3b21ef"),
    marko_node0 = marko_createElement("br", null, "65", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "text-muted"
      },
    marko_attrs8 = {
        "class": "py-1"
      },
    marko_attrs9 = {
        "class": "py-1"
      },
    marko_attrs10 = {
        "class": "text-primary"
      },
    marko_attrs11 = {
        "class": "py-1"
      },
    marko_attrs12 = {
        "class": "text-primary"
      },
    marko_attrs13 = {
        "class": "py-1"
      },
    marko_attrs14 = {
        "class": "list-inline"
      },
    marko_attrs15 = {
        "class": "px-1 py-25 m-25 round theme-bg-lighten"
      },
    marko_attrs16 = {
        "class": "py-1"
      },
    marko_attrs17 = {
        "class": "col-7"
      },
    marko_attrs18 = {
        "class": "btn btn-secondary btn-lg m-25"
      },
    marko_attrs19 = {
        "class": "col text-right"
      },
    marko_attrs20 = {
        "class": "btn btn-primary btn-lg m-25"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  Row_tag({
      class: "m-0 w-100 h-100 d-flex justify-content-center",
      renderBody: function(out) {
        out.e("div", marko_attrs1, "2", component, 0, 0, {
            onclick: __component.d("click", () => component.emit('dismiss'), false)
          });

        WSAdapt_tag({
            ns: "col-4",
            qs: "col-8",
            hs: "col-10",
            class: "animated fadeIn faster py-3",
            style: "padding-bottom:150px",
            renderBody: function(out) {
              Row_tag({
                  class: "d-flex align-items-center py-1",
                  col: [
                      {
                          class: "col-2",
                          renderBody: function(out) {
                            Bx_tag({
                                type: "cube-alt",
                                class: "font-large-4"
                              }, out, __component, "6");
                          }
                        },
                      {
                          renderBody: function(out) {
                            out.be("h5", null, "8", component);

                            Locale_tag({
                                text: state.app.name
                              }, out, __component, "9");

                            out.ee();

                            out.be("p", marko_attrs7, "10", component);

                            Locale_tag({
                                text: state.app.description
                              }, out, __component, "11");

                            out.ee();
                          }
                        }
                    ]
                }, out, __component, "4");

              out.be("ul", marko_attrs2, "12", component);

              out.be("li", marko_attrs3, "13", component);

              Row_tag({
                  col: [
                      {
                          class: "col-3 text-muted",
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Type"
                              }, out, __component, "16");
                          }
                        },
                      {
                          renderBody: function(out) {
                            Switch_tag({
                                by: state.app.type,
                                case: [
                                    {
                                        is: "WES",
                                        renderBody: function(out) {
                                          Locale_tag({
                                              renderBody: function(out) {
                                                out.t("Webhook Event Subscription (WES)");
                                              }
                                            }, out, __component, "20");
                                        }
                                      },
                                    {
                                        is: "API",
                                        renderBody: function(out) {
                                          Locale_tag({
                                              renderBody: function(out) {
                                                out.t("Application Program Interface (WES)");
                                              }
                                            }, out, __component, "22");
                                        }
                                      }
                                  ]
                              }, out, __component, "18");
                          }
                        }
                    ]
                }, out, __component, "14");

              out.ee();

              out.be("li", marko_attrs4, "23", component);

              Row_tag({
                  col: [
                      {
                          class: "col-3 text-muted",
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Status"
                              }, out, __component, "26");
                          }
                        },
                      {
                          renderBody: function(out) {
                            Locale_tag({
                                class: "text-primary",
                                text: state.app.status
                              }, out, __component, "28");
                          }
                        }
                    ]
                }, out, __component, "24");

              out.ee();

              if (state.app.configs.mode) {
                out.be("li", marko_attrs8, "29", component);

                Row_tag({
                    col: [
                        {
                            class: "col-3 text-muted",
                            renderBody: function(out) {
                              Locale_tag({
                                  text: "Mode"
                                }, out, __component, "32");
                            }
                          },
                        {
                            renderBody: function(out) {
                              Switcher_tag({
                                  options: [
                                      {
                                          value: "dev",
                                          label: "Dev",
                                          selected: state.app.configs.mode == "dev"
                                        },
                                      {
                                          value: "live",
                                          label: "Live",
                                          selected: state.app.configs.mode == "live"
                                        }
                                    ],
                                  color: "gey"
                                }, out, __component, "34", [
                                [
                                  "switch",
                                  mode => component.sendUpdate({ mode }),
                                  false
                                ]
                              ]);
                            }
                          }
                      ]
                  }, out, __component, "30");

                out.ee();
              }

              out.ee();

              out.be("ul", marko_attrs5, "35", component);

              if (state.app.configs.requestURL) {
                out.be("li", marko_attrs9, "36", component);

                Row_tag({
                    col: [
                        {
                            class: "col-3 text-muted",
                            renderBody: function(out) {
                              Locale_tag({
                                  text: "Request URL"
                                }, out, __component, "39");
                            }
                          },
                        {
                            renderBody: function(out) {
                              out.e("span", marko_attrs10, "41", component, 1)
                                .t(state.app.configs.requestURL, component);
                            }
                          }
                      ]
                  }, out, __component, "37");

                out.ee();
              }

              if (state.app.configs.eventTarget) {
                out.be("li", marko_attrs11, "42", component);

                Row_tag({
                    col: [
                        {
                            class: "col-3 text-muted",
                            renderBody: function(out) {
                              Locale_tag({
                                  text: "Event Target"
                                }, out, __component, "45");
                            }
                          },
                        {
                            renderBody: function(out) {
                              out.e("span", marko_attrs12, "47", component, 1)
                                .t(state.app.configs.eventTarget, component);
                            }
                          }
                      ]
                  }, out, __component, "43");

                out.ee();
              }

              if (state.app.configs.eventList) {
                out.be("li", marko_attrs13, "48", component);

                Row_tag({
                    col: [
                        {
                            class: "col-3 text-muted",
                            renderBody: function(out) {
                              Locale_tag({
                                  text: "Event List"
                                }, out, __component, "51");
                            }
                          },
                        {
                            renderBody: function(out) {
                              out.be("ul", marko_attrs14, "53", component);

                              var $for$0 = 0;

                              marko_forOf(state.app.configs.eventList, function(type, index) {
                                var $keyScope$0 = "[" + (($for$0++) + "]");

                                out.e("li", marko_attrs15, "54" + $keyScope$0, component, 1)
                                  .t(type, component);
                              });

                              out.ee();
                            }
                          }
                      ]
                  }, out, __component, "49");

                out.ee();
              }

              out.be("li", marko_attrs6, "55", component);

              Row_tag({
                  col: [
                      {
                          class: "col-3 text-muted",
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Created"
                              }, out, __component, "58");
                          }
                        },
                      {
                          renderBody: function(out) {
                            out.t(formatDate(state.app.created.at, "calendar"), component);
                          }
                        }
                    ]
                }, out, __component, "56");

              out.ee();

              if (state.app.updated) {
                out.be("li", marko_attrs16, "60", component);

                Row_tag({
                    col: [
                        {
                            class: "col-3 text-muted",
                            renderBody: function(out) {
                              Locale_tag({
                                  text: "Last Updates"
                                }, out, __component, "63");
                            }
                          },
                        {
                            renderBody: function(out) {
                              out.t(formatDate(state.app.updated.at, "calendar"), component);
                            }
                          }
                      ]
                  }, out, __component, "61");

                out.ee();
              }

              out.ee();

              out.n(marko_node0, component);

              Row_tag({
                  class: "px-2 py-1",
                  renderBody: function(out) {
                    out.be("div", marko_attrs17, "67", component);

                    out.be("button", marko_attrs18, "68", component, null, 0, {
                        onclick: __component.d("click", () => component.emit('dismiss'), false)
                      });

                    Locale_tag({
                        text: "Close"
                      }, out, __component, "69");

                    out.ee();

                    out.ee();

                    out.be("div", marko_attrs19, "70", component);

                    out.be("button", marko_attrs20, "71", component, null, 0, {
                        onclick: __component.d("click", "onDelete", false)
                      });

                    Locale_tag({
                        text: "Delete App"
                      }, out, __component, "72");

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "66");
            }
          }, out, __component, "3");
      }
    }, out, __component, "1");

  if (state.dialog) {
    const { message, actions, ...rest } = state.dialog

    DialogModal_tag(marko_assign({
        message: message,
        actions: actions
      }, rest), out, __component, "73", [
      [
        "dismiss",
        "onDialog",
        false,
        [
            false
          ]
      ]
    ]);
  }

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
